import { createSelector } from 'reselect';

import { IMembershipPlanPriceModel } from 'models/MembershipPlanPriceModel';

import { RootState } from '../../index';
import { ISRPricingState } from './index';

export const pricingSelector = (state: RootState) => state.srPricing;

export const srMembershipPlansPricesSelector = createSelector(
  pricingSelector,
  (pricing: ISRPricingState): IMembershipPlanPriceModel[] =>
    pricing.membershipPlansPrices,
);
